/**
 * Free Losi Max Limit Toast
 *
 * Custom toast for Free-plan Losi Max cooldown fallbacks.
 *
 * Primary responsibilities:
 * - Show the Mini fallback and Max reset timing clearly
 * - Open the premium modal from a Skip the wait button
 *
 * Dependencies:
 * - sonner
 * - lucide-react
 */

import { SkipForward } from 'lucide-react'
import { toast } from 'sonner'

import {
  getFreeLosiMaxFallbackMessage,
  type FreeLosiMaxLimitDetails
} from '@/lib/chat/free-losi-max-limit-notice'

type ShowFreeLosiMaxLimitToastArgs = {
  details: FreeLosiMaxLimitDetails | null
  onSkipWait?: () => void
}

export function showFreeLosiMaxLimitToast({
  details,
  onSkipWait
}: ShowFreeLosiMaxLimitToastArgs) {
  toast(
    () => (
      <div className="w-[min(360px,calc(100vw-32px))] rounded-xl border border-blue-500/60 bg-zinc-950/95 p-4 text-zinc-100 shadow-2xl shadow-black/30">
        <div className="flex flex-col gap-3">
          <div className="space-y-1">
            <p className="text-sm font-semibold leading-5 text-white">
              Free plan continues with Losi Mini
            </p>
            <p className="text-xs leading-5 text-zinc-300">
              {getFreeLosiMaxFallbackMessage(details)}
            </p>
          </div>
          <div className="flex items-center justify-end">
            <button
              type="button"
              onClick={() => {
                onSkipWait?.()
                toast.dismiss()
              }}
              className="inline-flex h-8 items-center justify-center gap-1.5 rounded-md bg-blue-500 px-3 text-xs font-semibold text-white shadow-sm shadow-blue-950/40 transition hover:bg-blue-400"
            >
              <SkipForward className="size-3.5" />
              <span>Skip the wait</span>
            </button>
          </div>
        </div>
      </div>
    ),
    {
      duration: 10000,
      position: 'bottom-center'
    }
  )
}
